import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, AfterContentInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, debounceTime, filter, startWith, switchMap, tap } from 'rxjs';
import { searchSortOptions } from 'src/app/models/search-sort-options';
import { NameValue } from 'src/app/models/name-value';

@Component({
  selector: 'app-typeahead-infinite-scroll',
  templateUrl: './typeahead-infinite-scroll.component.html',
  styleUrls: ['./typeahead-infinite-scroll.component.scss']
})
export class TypeaheadInfiniteScrollComponent implements OnInit, OnChanges, AfterContentInit {
	@Input() public mapMethod: (args: any) => NameValue
	@Input() public search: (searchText: string) => Observable<any[]>;
	@Input() public searchColumn: string;
	@Input() public fieldLabel: string;
	@Input() public initialValue: string;
	@Input() public status: boolean = true;
	@Input() public required: boolean = false;
		
	@Output() public processSelected: EventEmitter<any> = new EventEmitter<any>();
	@Output() public pageNumberChanged: EventEmitter<any> = new EventEmitter<any>();

	public autoCompleteForm: UntypedFormGroup;
	public isInit: boolean = false;
	public formIsBuilt: boolean = false;

	@ViewChild('objAuto') objAuto: any;
	filteredObjects: any[];
	public objSearchSortOptions: searchSortOptions;

  	constructor(private _formBuilder: UntypedFormBuilder) { }

	getObjDefinition(option) {
		return option && option.definition ? option.definition : option;
	}

	ngOnChanges() {
		if(this.formIsBuilt && !this.isInit && (this.initialValue?.length ?? 0) > 0)
		{
				this.autoCompleteForm?.get('objDisplay').setValue(this.initialValue);
				this.isInit = true;
		}
		if(!this.status)
			this.autoCompleteForm?.disable();
	}

	ngOnInit(): void {
		this.autoCompleteForm = this._formBuilder.group({
			objDisplay: ['', []]
		});
		this.formIsBuilt = true;
		this.ngOnChanges();
		
		if(this.required) 
			this.autoCompleteForm?.get('objDisplay').setValidators([Validators.required]);
		this.objSearchSortOptions = new searchSortOptions(10, 1, this.searchColumn, 'ASCENDING', this.searchColumn, '');
			this.autoCompleteForm?.get('objDisplay').valueChanges
			.pipe(
				filter(x => typeof x === 'string'),
				startWith(''),
				debounceTime(200),
				tap((searchText) => {
					this.filteredObjects = [];
					this.objSearchSortOptions.searchText = searchText;
					this.objSearchSortOptions.pageNumber = 1;
				}),
				switchMap(searchText => this.search(searchText))
			)
			.subscribe({
				next: (response) => {	
					this.filteredObjects = response;
				}
			});
	}

	ngAfterContentInit() {
		this.ngOnChanges();
	}
	
	onObjScroll() {
		this.objSearchSortOptions.pageNumber = this.objSearchSortOptions.pageNumber + 1;
		this.pageNumberChanged.emit(this.objSearchSortOptions.pageNumber);
		this.search(this.objSearchSortOptions.searchText).subscribe((response) => {
			if (response?.length > 0) {
				this.filteredObjects = this.filteredObjects.concat(response);
			}
		});
	}

	setObj(event) {
		let nameValue = this.mapMethod(event);
		this.autoCompleteForm?.get('objDisplay').setValue(nameValue.name);
		this.processSelected.emit(nameValue.value);
		this.autoCompleteForm?.get('objDisplay').markAsDirty();
	}

}
